import React from 'react';
import { observer } from 'mobx-react';
import { CapacityPlannerScreen } from '../../screen/CapacityPlanner/Screen';

interface Props { planner: CapacityPlannerScreen; }

@observer
export class Toaster extends React.Component<Props> {
    render() {
        const p = this.props.planner;
        return (
            <div className="toast-container" data-test-cp-toast-container>
                {p.toasts.map(t => (
                    <div key={t.id} className={'toast ' + t.type}>{t.message}</div>
                ))}
            </div>
        );
    }
}
